import Axios from '@/axios'

// 查询行业：web:industry:index
export const QueryIndustryList = data => {
  return Axios({
    url: '/device-manager/web-api/industry/index',
    method: 'POST',
    type: 'json',
    data
  })
}
// 查询所有行业的id名称：web:industry:listIdName
export const QueryIndustrySimplifyList = () => {
  return Axios({
    url: '/device-manager/web-api/industry/list_id_name',
    method: 'POST',
    type: 'json'
  })
}

// 创建行业：web:industry:create
export const IndustryCreate = data => {
  return Axios({
    url: '/device-manager/web-api/industry/create',
    method: 'POST',
    type: 'json',
    data
  })
}

// 修改行业：web:industry:update
export const IndustryUpdate = data => {
  return Axios({
    url: `/device-manager/web-api/industry/update/${data.id}`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 删除行业：web:industry:delete
export const IndustryDelete = id => {
  return Axios({
    url: `/device-manager/web-api/industry/delete/${id}`,
    method: 'POST',
    type: 'json'
  })
}

// 重置应用密钥：web:industry:resetAppKey
export const IndustryResetKey = id => {
  return Axios({
    url: `/device-manager/web-api/industry/update/${id}`,
    method: 'POST',
    type: 'json'
  })
}
